// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2460":"6627ed552d3a363a","3197":"a1691a976b9eb80b","4500":"56d1f5034e1e3936","4535":"218871522266932a","8734":"9dbff2e13711323a"}[chunkId] + ".css";
};